import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div``;

export const Section = styled.div`
  padding: 20px 24px;
`;

export const ItemList = styled.ul``;

export const ItemListItem = styled.li`
  margin-bottom: 16px;
`;

export const LinkWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  max-width: 100%;
  overflow: hidden;
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 12px;
  background-color: white;
  border: 1px solid var(--border1);
  cursor: pointer;
  margin-right: 12px;
  transition: background-color 0.2s ease;
  flex: 1;
  min-width: 0;

  &:hover {
    background-color: var(--hover1);
  }
`;

export const LinkTextContainer = styled.div`
  max-width: calc(100% - 80px);
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const LinkButtonContainer = styled.div`
  max-width: 80px;
  min-width: 80px;
  display: flex;
  justify-content: flex-end;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--neut6);
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  min-width: 48px;
  background-color: var(--neut5);
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--neut4);
  }
`;

export const PdfPreview = styled.iframe`
  width: 100%;
  height: 600px;
  border: 1px solid var(--border1);
  border-radius: 4px;
  background-color: white;

  @media (max-width: 768px) {
    height: 400px;
  }
`;

export const UpgradeLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  border-radius: 4px;
  background-color: var(--danger);
  border: 1px solid #fed7aa;
  color: var(--white);
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  position: relative;
  overflow: hidden;
`;
